var map = {
	"./echo.js": "891b",
	"./index.js": "2f58",
	"./joychat.js": "9a19",
	"./joyu.js": "a36d",
	"./kiko.js": "43d1",
	"./vava.js": "2e97",
	"./vibeo.js": "de8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9b1";